import {
    FormControl,
    FormControlLabel,
    FormHelperText,
    FormLabel,
    Radio,
    RadioGroup,
    SxProps,
    Theme
} from "@mui/material";
import React from "react";

type CNBSRadioGroupInputProps = {
    label: string
    formControlSx?: SxProps<Theme>,
    value: string,
    onChange: (event: React.ChangeEvent<HTMLInputElement>, value: string) => void,
    options: { value: string, label: string }[]
    error?: string
    disabled?: boolean
}

function CNBSRadioGroupInput({label, formControlSx, value, onChange, options, error, disabled = false}: CNBSRadioGroupInputProps) {
    return (
        <FormControl sx={formControlSx} disabled={disabled}>
            <FormLabel>{label}</FormLabel>

            <RadioGroup row value={value} onChange={onChange}>
                {options.map(o => <FormControlLabel
                    key={o.value}
                    value={o.value}
                    control={<Radio disabled={disabled} />}
                    label={o.label}
                />)}
            </RadioGroup>

            <FormHelperText error={!!error}>{error}</FormHelperText>
        </FormControl>
    )
}

export default CNBSRadioGroupInput
